export const Marquee = ({ items }) => {
    const row = [...items, ...items];
    return (
        <div
            className="marquee-hover relative overflow-hidden border-y border-white/10 bg-[#01537B] py-5"
            data-testid="editorial-marquee"
            aria-hidden="true"
        >
            <div className="animate-marquee flex w-max items-center">
                {row.map((item, i) => (
                    <span key={i} className="flex items-center">
                        <span className="font-display whitespace-nowrap px-8 text-lg italic text-[#F7EAB8]/90 md:text-xl">
                            {item}
                        </span>
                        <span className="h-1.5 w-1.5 rounded-full bg-[#14B8A6]" />
                    </span>
                ))}
            </div>
        </div>
    );
};
